export const registerScreenStyles = {
  container: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: '100%',
    maxWidth: 500,
    padding: 4,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    marginBottom: 3,
    fontWeight: 600,
  },
  form: {
    width: '100%',
    marginTop: 2,
  },
  input: {
    marginBottom: 2,
  },
  submitButton: {
    marginTop: 2,
    marginBottom: 2,
    height: 48,
  },
  loginLink: {
    textAlign: 'center',
    marginTop: 2,
  },
};
